import { theme } from 'antd';
import React, { ReactNode, useEffect, useMemo, useRef, useState } from 'react';

export default function HeightAnimator({ children }: { children?: ReactNode }): JSX.Element {
  const { token } = theme.useToken();
  const transition = `min-height ${token.motionDurationMid} ${token.motionEaseOut}, max-height ${token.motionDurationMid} ${token.motionEaseOut}`;
  const [height, setHeight] = useState(0);
  const innerRef = useRef<HTMLDivElement | null>(null);
  const observer = useMemo(
    () =>
      new ResizeObserver((entries) => {
        // Work around some weird racing at startup
        requestAnimationFrame(() => Array.isArray(entries) && entries.length && setHeight(entries[0].contentRect.height));
      }),
    [],
  );
  useEffect(() => {
    if (innerRef.current) {
      observer.observe(innerRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [innerRef.current]);
  return (
    <div style={{ minHeight: height, maxHeight: height, overflow: 'hidden', transition }}>
      <div ref={innerRef}>{children}</div>
    </div>
  );
}
